import type { FieldError } from "react-hook-form";
import cn from "classnames";
import style from "./ErrorMessage.module.scss";

type ErrorMessageProps = {
  error?: FieldError;
  className?: string;
};

export const ErrorMessage = ({ error, className }: ErrorMessageProps) => {
  if (!error?.message) {
    return null;
  }

  return (
    <p
      className={cn(style.errorMessage, className, {
        [style.relative]: error.message.length > 60,
      })}
    >
      {error.message}
    </p>
  );
};
